/**
 * This is a transitional file that re-exports the refactored TestChat component
 * from its new folder structure. This ensures backward compatibility with
 * existing imports while we migrate to the new structure.
 */

import TestChat from './TestChat/';
export default TestChat;